import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import i18n from "./plugins/i18n"

Vue.config.productionTip = false

// Plugins custom
require("./plugins/opq.js")
require("./plugins/filters.js")
require('./plugins/constants')

// Facade
import InputFacade from 'vue-input-facade'
Vue.use(InputFacade)

// Instance Vue
new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')